import { render, staticRenderFns } from "./FirstScreenVideo.vue?vue&type=template&id=dad46db2&scoped=true"
import script from "./FirstScreenVideo.vue?vue&type=script&lang=js"
export * from "./FirstScreenVideo.vue?vue&type=script&lang=js"
import style0 from "./FirstScreenVideo.vue?vue&type=style&index=0&id=dad46db2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad46db2",
  null
  
)

export default component.exports